import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";

/**
 * Form input with optional label, error state, and helper text. Pairs cleanly
 * with React Hook Form — pass register("field") into the spread.
 */
export const Input = forwardRef(
  ({ label, error, hint, className, id, type = "text", required, ...props }, ref) => {
    const inputId = id ?? `inp-${Math.random().toString(36).slice(2, 8)}`;
    return (
      <div className="space-y-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-xs font-medium uppercase tracking-wider text-text-secondary"
          >
            {label}
            {required && <span className="ml-1 text-danger">*</span>}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          type={type}
          className={cn(
            "w-full rounded-md border bg-bg-elevated px-3 py-2 text-sm text-text-primary placeholder:text-text-muted",
            "focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent",
            error ? "border-danger focus:border-danger focus:ring-danger" : "border-border",
            className
          )}
          {...props}
        />
        {error && <p className="text-xs text-danger">{error}</p>}
        {!error && hint && <p className="text-xs text-text-muted">{hint}</p>}
      </div>
    );
  }
);
Input.displayName = "Input";
